module.exports = require('./helpers/bundle-url').getBundleURL('bu0dN') + "06f1a8efc291c_001.329671b7.webp";